export default __webpack_public_path__ + "static/media/845.594bd4f5.png";